import { Component, OnDestroy, inject } from '@angular/core';

import { ApiKey } from '@rhapsody/ngx-api-key-client';
import { CommonModule } from '@angular/common';
import { KeyService } from '@core/services/key.service';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormField } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'rh-create-key',
    imports: [
        CommonModule,
        MatCardModule,
        MatChipsModule,
        MatFormField,
        MatInputModule,
        MatGridListModule,
    ],
    templateUrl: './create-key.component.html',
    styleUrl: './create-key.component.scss'
})
export class CreateKeyComponent implements OnDestroy {
  private readonly keyService = inject(KeyService);

  get createdKey$(): ApiKey | null {
    const key = this.keyService.createdKey();
    return key;
  }

  get createdKeyObject(): string[] {
    const key = this.keyService.createdKey();
    return key ? Object.keys(key) : [];
  }

  get createKeyError$(): string | null {
    const error = this.keyService.createKeyError();
    return error ?? null;
  }

  ngOnDestroy(): void {
    this.reset();
  }

  public reset() {
    this.keyService.resetCreatedKey();
  }
}
